import type { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { Badge } from '@ui/badge.tsx';
import type { ReferenceReferenceReadModel } from '@r/api/generated/client.schemas.ts';

export const useProductReferenceColumns = (): ColumnDef<ReferenceReferenceReadModel>[] => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'brand',
      header: t('label.product.brand')
    },
    {
      accessorKey: 'productLine',
      header: t('label.product.range')
    },
    {
      accessorKey: 'name',
      header: t('label.product.name')
    },
    {
      accessorKey: 'uniqueCode',
      header: t('label.product.reference')
    },
    {
      accessorKey: 'pointValue',
      header: t('label.product.value')
    },
    {
      accessorKey: 'tags',
      header: t('label.product.tags'),
      cell: ({ row }) => {
        const tags = row.original.tags ?? [];

        if (tags.length === 0) {
          return (
            <span className="text-sm text-muted-foreground">{t('label.product.tags.empty')}</span>
          );
        }

        return (
          <div className="flex flex-wrap gap-1">
            {tags.map((tag) => (
              <Badge key={tag} variant="outline" className="font-normal">
                {tag}
              </Badge>
            ))}
          </div>
        );
      },
      enableSorting: false
    }
  ];
};
